import { useCallback } from 'react';
import ReportComparisonDropdown from 'report-customization-components/components/comparison-dropdown/ReportComparisonDropdown';
import { DateActionTypes } from 'reporting-ui-components/constants/trackingConstants';
import { EVENTS } from 'reporting-ui-components/lib/events';
import { getUsageTracker } from 'reporting-ui-components/monitoring/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const SRVReportComparisonDropdown = ({
  report,
  onChange,
  trackingAssetType,
  trackingApplicationName,
  trackingScreenName,
  isV2FilterExperience
}) => {
  const usageTracker = getUsageTracker();
  const onCompareChange = useCallback(changeReport => {
    usageTracker.track(EVENTS.changeSrvDateFilters, {
      action: DateActionTypes.COMPARED_TO,
      assetType: trackingAssetType || 'report',
      applicationName: trackingApplicationName,
      whereScreen: trackingScreenName,
      isNewFilterExperience: isV2FilterExperience
    });
    onChange(changeReport);
  }, [usageTracker, trackingAssetType, trackingApplicationName, trackingScreenName, isV2FilterExperience, onChange]);
  return /*#__PURE__*/_jsx(ReportComparisonDropdown, {
    report: report,
    onChange: onCompareChange
  });
};